import { default as sectoralBDData } from './sectoralBDData.json';
import { default as differentFuelsData } from './differentFuels.json';
const data = {
    sectoralBD: sectoralBDData,
    differentFuels: differentFuelsData
};
function getMockData(dataset) {
    return data[dataset];
}
export const sectoralBD = getMockData('sectoralBD');
export const differentFuels = getMockData('differentFuels');
